import { asString, isObject } from "./model-utils";

export class Author {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.id = asString(json._id || json.id);
    this.userId = asString(json.userId);
    this.email = asString(json.email);
    this.name = asString(json.name);
    this.phone = asString(json.phone);
    this.image = asString(json.image);
    this.userType = asString(json.userType);
    this.memberId = asString(json.memberId);
  }

  static fromJson(json: any) {
    return isObject(json) ? new Author(json) : json;
  }
}
